import { boolean, number, object, string } from 'yup'
import {
  DEFAULT_PLAN_TARGET_VIEWER,
  PLAN_TARGET_VIEWER_OPTIONS,
} from '@editor/pages/PlanView/constants'

export const planSettingsValidationSchema = object({
  paperFormat: string().oneOf(['A3', 'A2', 'A1']).default('A2').required(),
  orientation: string().oneOf(['landscape', 'portrait']).default('landscape').required(),
  scale: number().positive().default(50).required(),
  fontSize: number().positive().default(8).required(),
  user_defined_origin: object({
    x: number().default(0.05),
    y: number().default(0.05),
  }),
  targetViewer: string()
    .oneOf(PLAN_TARGET_VIEWER_OPTIONS.map(option => option.value))
    .default(DEFAULT_PLAN_TARGET_VIEWER)
    .required(),
  showShearAnchorCount: boolean().default(true).required(),
})
